// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"291":"b422bb5ad1c30b97","805":"72ef676d85668738"}[chunkId] + ".js";
};